// Example service: filepath: /home/boss/workspace/pwa/zgrana/src/app/services/example.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { EditPartner, Partner, PartnerGroup } from '../interfaces/partners.interface';
import { DataProcessingService } from './data-prcessing.service';
import { EditPage, Page } from '../interfaces/pages.interface';
import { LoggerService } from './logger.service';

@Injectable({ providedIn: 'root' })
export class PagesService {
   private get apiUrl(): string {
     return this.loggerService.resolveApiUrl('page');
   }

   constructor(
     private http: HttpClient,
     private dataProcess: DataProcessingService,
     private loggerService: LoggerService
   ) {}

  getPages(params?: {
    order_by?: string;
    order?: string;
    skip?: number;
    limit?: number;
    [key: string]: any; // for filters
  }): Observable<GenericResponseWithTotal<Page>> {
    params = params || {};// Default to active partners
    return this.http.get<GenericResponseWithTotal<Page>>(this.apiUrl, { params: this.dataProcess.fitlerParams(params) });
  }


  getPage(idOrTag: number | string): Observable<Page> {
    // Try to convert to number
    const numId = Number(idOrTag);
    if (!isNaN(numId) && typeof idOrTag !== 'boolean' && idOrTag !== null && idOrTag !== '') {
      return this.http.get<Page>(`${this.apiUrl}/${numId}`);
    }
    return this.http.get<Page>(`${this.apiUrl}/tag/${idOrTag}`);
  }

  updatePage(id: number, data: EditPage): Observable<Page> {
    return this.http.put<Page>(`${this.apiUrl}/${id}`, data);
  }

  createPage(data: Partial<EditPage>): Observable<Page> {
    return this.http.post<Page>(this.apiUrl, data);
  }

  deletePage(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

}